import React from "react";
import {
  Button,
  Grid,
  MenuItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

import CrmShell from "../components/CrmShell";
import { CrmPageHeader, CrmPanel, OwnerCell, crmUi } from "../components/CrmUi";
import DealPipeline from "../components/DealPipeline";
import { deals } from "../demoData";

const money = value => new Intl.NumberFormat("sv-SE").format(value) + " kr";

const CrmDealsPage = () => (
  <CrmShell>
    <CrmPageHeader
      title="Affärer"
      subtitle="Försäljningsmöjligheter från första kontakt till vunnen affär."
      actions={[
        <Button key="new" size="small" variant="contained" startIcon={<AddOutlinedIcon />} sx={{ textTransform: "none" }}>
          Ny affär
        </Button>,
      ]}
    />

    <CrmPanel sx={{ p: 1.4, mb: 1.15 }}>
      <Typography sx={{ color: crmUi.text, fontSize: 13.5, fontWeight: 550 }}>Pipeline</Typography>
      <Typography sx={{ mt: 0.15, color: crmUi.muted, fontSize: 10.2 }}>
        Värde och antal affärer per fas.
      </Typography>
      <Grid container spacing={1} sx={{ mt: 0.45 }}>
        <Grid item xs={12}>
          <DealPipeline />
        </Grid>
      </Grid>
    </CrmPanel>

    <CrmPanel sx={{ overflow: "hidden" }}>
      <Stack direction={{ xs: "column", md: "row" }} spacing={0.7} sx={{ p: 1.1, borderBottom: `1px solid ${crmUi.border}` }}>
        <TextField size="small" placeholder="Sök affärer..." sx={{ flex: 1 }} />
        {["Fas", "Ansvarig", "Organisation"].map(label => (
          <TextField key={label} size="small" select defaultValue="" sx={{ minWidth: 130 }}>
            <MenuItem value="">{label}</MenuItem>
          </TextField>
        ))}
      </Stack>

      <TableContainer>
        <Table size="small" sx={{ minWidth: 940 }}>
          <TableHead>
            <TableRow sx={{ bgcolor: "#fbfcfd" }}>
              {["Affär", "Organisation", "Fas", "Värde", "Sannolikhet", "Ansvarig", "Förväntat avslut", "Senaste aktivitet"].map(x => (
                <TableCell key={x} sx={{ py: 0.9, color: crmUi.muted, fontSize: 9.6, fontWeight: 550 }}>{x}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {deals.map(deal => (
              <TableRow key={deal.id} hover>
                <TableCell sx={{ fontSize: 10.8, color: crmUi.text, fontWeight: 520 }}>{deal.name}</TableCell>
                <TableCell sx={{ fontSize: 10.4 }}>{deal.organization}</TableCell>
                <TableCell sx={{ fontSize: 10.4 }}>{deal.stage}</TableCell>
                <TableCell sx={{ fontSize: 10.4 }}>{money(deal.value)}</TableCell>
                <TableCell sx={{ fontSize: 10.4 }}>{deal.probability}%</TableCell>
                <TableCell><OwnerCell name={deal.owner} /></TableCell>
                <TableCell sx={{ fontSize: 10.2 }}>{deal.closeDate}</TableCell>
                <TableCell sx={{ fontSize: 10.2, color: crmUi.muted }}>{deal.activity}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </CrmPanel>
  </CrmShell>
);

export default CrmDealsPage;
